<template>
    <div class="main-container-l">
        <div class="loading-container" v-if="offerStore.offerLoading"><img src="../../assets/img/loading.svg"></div>
        <div class="offer-container-l horses-container" ref="tourCont" v-else>
            <div class="vhorses-left-container">
                <div class="horses-live-stream" v-if="vhorseRacesExist">
                    <HorsesVideoPlayer
                        :link="videoUrl"
                        :isControls="false"
                        :isMuted="true"
                    />
                </div>
                <vhorse-last-race
                    v-if="!offerStore.offerLoading"
                    :isMobile.prop="isMobile"
                    :offer.prop="offerInstance"
                    :clientName.prop="getClientName"
                    :t.prop="$t"
                    :customCss.prop="customCss"
                    :clientStylingUrl.prop="styleUrl"
                    class="desktop-web-cmp"
                />
            </div>
            <div class="vhorses-right-container">
                <horses-future-races
                    v-if="!offerStore.offerLoading"
                    :isMobile.prop="isMobile"
                    :clientName.prop="getClientName"
                    :offer.prop="offerInstance"
                    :t.prop="$t"
                    :customCss.prop="customCss"
                    :clientStylingUrl.prop="styleUrl"
                    @selectrace="onSelectRace"
                    class="desktop-web-cmp vhorses-future-races"
                />
                <horses-betting
                    :selectedMarketId.prop="marketId"
                    :clientStylingUrl.prop="styleUrl"
                    :t.prop="$t"
                    @selectedMarket="onSelectMarket"
                    class="desktop-web-cmp"
                />
                <horses-outcomes
                    v-if="betslip"
                    :selectedMarketId.prop="marketId"
                    :offer.prop="offerInstance"
                    :betslipInit.prop="betslip"
                    :selectedVhorseRace.prop="selectedRace"
                    :t.prop="$t"
                    :customCss.prop="customCss"
                    :clientStylingUrl.prop="styleUrl"
                    @selectoutcome="onSelectOutcome"
                    class="desktop-web-cmp"
                />
            </div>
            <div class="betslip-ticket-list-container">
                <new-betslip v-if="betslipStore && betslip" />
            </div>
            <router-link
                v-if="showLottoResultsButton && getResultsRoute != null && isMobile"
                class="button button-results-lotto full"
                :to="{ path: getResultsRoute }">
                {{$t('RESULTS')}}
            </router-link>
        </div>
    </div>
</template>

<script>

import
{
    mapGetters,
}
from 'vuex';
import { mapActions as piniaActions, mapState as piniaState } from 'pinia';
import { useOfferStore } from '../store/piniaStore/offer';
import { useBetslipStore } from '../store/piniaStore/betslip';
import { useCustomizationStore } from '../store/piniaStore/customization';
import NewBetslip from '../components/betslip/NewBetslip.vue';
import HorsesVideoPlayer from './containers/HorsesVideoPlayer.vue';

export default
{
    name: 'Horses',
    components:
    {
        /* Created new component just for horses, kept old one in case it's used elsewhere */
        HorsesVideoPlayer,
        NewBetslip,
    },
    data()
    {
        return {
            betslipStore: null,
            offerInstance: null,
            styleUrl: '/web/css/fe-style.css,/web/css/assets.css',
            marketId: '1',
            lastAction: null,
            selectedOutcome: {},
            selectedRace: null,
            videoUrl: '',
        };
    },
    async created()
    {
        const me = this;

        me.betslipStore = useBetslipStore();
        me.betslip = me.betslipStore.getBetslip();
        me.offerStore = useOfferStore();
        me.betslipStore.clearItems('vhorse');
        me.offerInstance = me.offerStore.getOfferInstance();

        /* me.betslip.changeBetslipDefinition('simple'); */

        if (this.checkMaintenance())
        {
            return;
        }

        try
        {
            me.videoUrl = me.globals.publicConfig.vhorse.streamUrl;

            await me.initVHorseOffer();
        }
        catch (error)
        {
            console.error(error);
        }
    },
    beforeDestroy()
    {
        const me = this;
        me.destroyVHorseOffer();
    },
    methods:
    {
        ...piniaActions(useOfferStore, ['initOffer', 'initVHorseOffer', 'destroyVHorseOffer']),
        async selectVhorseInit(raceId)
        {
            const me = this;

            try
            {
                await me.selectVhorseRace(raceId);
            }
            catch (error)
            {
                console.log(error);
            }
        },
        async onSelectOutcome(payload)
        {
            const [data] = payload.detail;
            this.lastAction = 'selection';
            if (data.outcome != null)
            {
                window.localStorage.setItem(
                    'vhorse',
                    JSON.stringify([data]),
                );
            }
            else
            if (data.outcome == null && String(data.race.dailyInstanceId) === this.selectedRace)
            {
                window.localStorage.setItem(
                    'vhorse',
                    JSON.stringify([]),
                );
            }
        },
        onSelectRace(payload)
        {
            const [payloadData] = payload.detail;
            if (!payloadData)
            {
                return;
            }
            this.selectedRace = String(payloadData.dailyInstanceId);

            if (window.localStorage.getItem('vhorse') != null
             && JSON.parse(window.localStorage.getItem('vhorse')).length)
            {
                const data = JSON.parse(window.localStorage.getItem('vhorse'))[0];
                if ((String(data.race.dailyInstanceId) === this.selectedRace))
                {
                    this.selectedOutcome = data.outcome;
                }
                else
                {
                    this.selectedOutcome = {};
                }
            }
        },
        onSelectMarket(data)
        {
            const [marketId] = data.detail;
            this.marketId = marketId;
        },
        checkMaintenance()
        {
            if (this.maintenance && this.maintenance.vhorse)
            {
                this.$router.push({ name: 'maintenance' });
                return true;
            }

            return false;
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'vhorseRaces',
            'selectedVhorseRace',
            'isMobile',
            'smallDesktop',
            'selectedItem',
            'maintenance',
            'playerdata',
            'resultsAvailable',
        ]),
        vhorseRacesExist()
        {
            return !!this.offerInstance && !!this.offerInstance.vhorse.races;
        },
        ...piniaState(useCustomizationStore, ['customCss']),
        getClientName()
        {
            // eslint-disable-next-line no-undef
            return CLIENT_NAME;
        },
        getResultsRoute()
        {
            const me = this;

            if (me.resultsAvailable.horses
            && me.getClientName === 'admiral')
            {
                return '/web/results/horses';
            }

            return null;
        },
        showLottoResultsButton()
        {
            const me = this;

            if (me.globals
            && me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website
            && me.globals.publicConfig.website.extraButtonOptions
            && me.globals.publicConfig.website.extraButtonOptions.displayResultsButtonAboveBetslip)
            {
                return true;
            }

            return false;
        },
    },
    watch:
    {
        'betslip.items.length':
        {
            handler(val)
            {
                if (this.lastAction === 'selection')
                {
                    this.lastAction = null;
                }
                else if (val === 0)
                {
                    window.localStorage.setItem(
                        'vhorse',
                        JSON.stringify([]),
                    );
                }
            },
        },
        maintenance()
        {
            this.checkMaintenance();
        },
    },
};

</script>
